// 발송 완료 안내 — 뒤 4자리는 괄호로 묶어 끝자리에 따라 조사가 갈리지 않게 한다.
const SentLinkNote = ({ last4, docName }: { last4: string; docName: "견적서" | "계약서" }) => (
  <>
    아래 링크를 고객에게 보내 주세요. 고객은 휴대폰 뒤 4자리(
    <b className="font-semibold text-foreground">{last4}</b>)를 입력하면 {docName}를 볼 수 있습니다.
  </>
);

export default SentLinkNote;
